<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :md="6" :sm="8" v-if="this.$store.getters.application.applicationType === 'platform'">
            <a-form-item :label="language['premission.applicationName']">
              <a-select v-model="queryParam.applicationCode" allowClear :placeholder="language['column.pleaseChoose']+language['premission.applicationName']">
                <a-select-option v-for="(application,index) in applicationList" :key="index.toString()" :value="application.applicationCode">
                  {{ application.applicationName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <a-form-item :label="language['system.dataLog.dataTable']">
              <a-input :placeholder="language['common.pleaseInput']+language['system.dataLog.dataTable']" v-model="queryParam.dataTable"></a-input>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <a-form-item :label="language['system.dataLog.dataId']">
              <a-input :placeholder="language['common.pleaseInput']+language['system.dataLog.dataId']" v-model="queryParam.dataId"></a-input>
            </a-form-item>
          </a-col>

          <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
               <a-col :md="6" :sm="24">
                  <a-button type="primary" @click="searchQuery">{{language['common.searchButton']}}</a-button>
                  <a-button style="margin-left: 8px" @click="searchReset">{{language['common.resetButton']}}</a-button>
               </a-col>
            </span>
        </a-row>
      </a-form>
    </div>

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleCompare()" type="primary" icon="plus">{{ language['system.dataLog.dataCompare'] }}</a-button>
    </div>

    <!--table区 -->
    <div>
      <!--已选择的清空 -->
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i>{{ language['common.choosed'] }}&nbsp;<a style="font-weight: 600">{{ selectedRowKeys.length }}</a>{{language['common.item']}}&nbsp;&nbsp;
        <a style="margin-left: 24px" @click="onClearSelected">{{ language['common.clear'] }}</a>
      </div>
      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{selectedRowKeys: selectedRowKeys,onChange: onSelectChange}"
        @change="handleTableChange"
      >
        <!-- 字符串超长截取省略号显示-->
        <span slot="dataContent" slot-scope="text, record">
          <j-ellipsis :value="text" :length="80" />
        </span>
      </a-table>
    </div>
    <data-log-modal ref="modalForm" @ok="modalFormOk"></data-log-modal>
  </a-card>
</template>

<script>
  import DataLogModal from './modules/DataLogModal'
  import {JeecgListMixin} from '@/mixins/JeecgListMixin'
  import JEllipsis from "@/components/jeecg/JEllipsis";
  import { getAction,putAction,httpAction  } from '@/api/manage'

  export default {
    name: 'DataLogList',
    mixins: [JeecgListMixin],
    components: {
      JEllipsis,
      DataLogModal
    },
    data() {
      return {
        description: '数据日志管理页面',
        //表头
        columns: [
          {
            title: this.$store.getters.language['system.dataLog.dataTable'],
            align: 'center',
            dataIndex: 'dataTable',
            width: "120"
          }, {
            title: this.$store.getters.language['system.dataLog.dataId'],
            align: 'center',
            dataIndex: 'dataId',
            width: "120"
          }, {
            title: this.$store.getters.language['system.dataLog.dataVersion'],
            align: 'center',
            dataIndex: 'dataVersion',
            width: "50"
          }, {
            title: this.$store.getters.language['system.dataLog.dataContent'],
            align: 'center',
            dataIndex: 'dataContent',
            width: "150",
            scopedSlots: {customRender: 'dataContent'},
          }, {
            title: this.$store.getters.language['system.dataLog.createBy'],
            align: 'center',
            dataIndex: 'createBy',
            width: "100"
          },
        ],
        url: {
          list: this.$store.getters.application.applicationType=='platform'?"/sys/dataLog/list":"/sys/dataLog/list?applicationCode="+this.$store.getters.applicationCode,
          // list: this.$store.getters.application.applicationType=='platform'?"/sys/user/list":"/sys/role/list?applicationId="+this.$store.getters.application.id,
        },
        applicationList:[],
      }
    },
    created() {
      if(this.$store.getters.application.applicationType === 'platform') {
        this.getApplicationList();
      }
    },
    computed:{
      language() {
        return this.$store.getters.language
      },
    },
    methods: {
      getApplicationList(){
        getAction("/sys/sysBmApplication/queryList").then((res) => {
          if (res.success) {
            this.applicationList = res.result;
          }
        })
      },
      handleCompare: function () {
        if (!this.selectionRows || this.selectionRows.length != 2) {
          this.openNotifIcon(this.language['system.dataLog.warning1']);
          return false;
        } else if (this.selectionRows[0].dataId != this.selectionRows[1].dataId) {
          this.openNotifIcon(this.language['system.dataLog.warning2']);
          return false;
        } else {
          this.$refs.modalForm.addModal(this.selectionRows);
          this.$refs.modalForm.title = this.language['system.dataLog.dataCompare'];
        }
      },
      openNotifIcon(msg) {
        this.$notification['warning']({
          message: this.language['common.promptMessage'],
          description: msg,
        });
      },
    }

  }

</script>
<style scoped>
  @import '~@assets/less/common.less'
</style>